import { BASE_SERVICE_URI } from '../../constants/ApiConstants';
import { registerQuery, useQuery } from '../../utils/DataFetchingClient';
import { http } from '../http';
export const TEAM_API = `${BASE_SERVICE_URI}/progress/v1/team`;
export const AWARDS_BY_TRACK_URL = `${TEAM_API}/awards`;
export const TEAM_AWARDS_PROGRESS_URL = `${TEAM_API}/progress`;
export const USER_AWARDS_PROGRESS_URL = `${TEAM_AWARDS_PROGRESS_URL}/user`;
const GET_ALL_AWARDS_BY_TRACK = registerQuery({
  fieldName: 'awardsByAsset',
  args: [],

  fetcher() {
    return http.get(AWARDS_BY_TRACK_URL);
  }

});
export const useAwardsByTrack = ({
  skip
} = {}) => {
  const {
    data: awardsByTrackResponse,
    loading: awardsByTrackLoading,
    error: awardsByTrackError
  } = useQuery(GET_ALL_AWARDS_BY_TRACK, {
    skip
  });
  const awardsByTrack = awardsByTrackResponse ? awardsByTrackResponse.trackToTeamAwardsMap : null;
  return {
    awardsByTrack,
    awardsByTrackLoading,
    awardsByTrackError
  };
};
const GET_TEAM_AWARDS_PROGRESS = registerQuery({
  fieldName: 'teamAwardsProgress',
  args: ['pageSize', 'pageNumber', 'query'],

  fetcher({
    pageSize,
    pageNumber,
    query
  }) {
    return http.get(TEAM_AWARDS_PROGRESS_URL, {
      query: {
        pageSize,
        pageNumber,
        query
      }
    });
  }

});
export const useTeamAwardsProgress = ({
  skip,
  pageSize,
  pageNumber,
  query
} = {}) => {
  const {
    data: teamAwardsProgressResponse,
    loading: teamAwardsProgressLoading,
    error: teamAwardsProgressError
  } = useQuery(GET_TEAM_AWARDS_PROGRESS, {
    skip,
    variables: {
      pageSize,
      pageNumber,
      query
    }
  });
  return {
    teamAwardsProgress: teamAwardsProgressResponse,
    teamAwardsProgressLoading,
    teamAwardsProgressError
  };
};
const GET_USER_AWARDS_PROGRESS = registerQuery({
  fieldName: 'userAwardsProgress',
  args: [],

  fetcher() {
    return http.get(USER_AWARDS_PROGRESS_URL);
  }

});
export const useUserAwardProgress = ({
  skip
} = {}) => {
  const {
    data: userAwardProgressResponse,
    loading: userAwardProgressLoading,
    error: userAwardProgressError
  } = useQuery(GET_USER_AWARDS_PROGRESS, {
    skip
  });
  return {
    userAwardProgress: userAwardProgressResponse,
    userAwardProgressLoading,
    userAwardProgressError
  };
};